import { memo } from 'react';

import useTranslation from '@Queries/useTranslation';
import icons from './icons';
import styles from './UsefullBlock.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { UsefullItemData } from '@Pages/PageExpressDesign/type';

interface UsefullBlockProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  items: UsefullItemData[];
}

const UsefullBlock: FC<UsefullBlockProps> = (props) => {
  const { className, items, ...restProps } = props;
  const { t } = useTranslation();

  return (
    <div {...restProps} className={className}>
      <div className={styles.title}>{t('when-usefull')}</div>
      <div className={styles.content}>
        <div className={styles.items}>
          {items.map(({ id, img, text }) => {
            return (
              <div className={styles.item} key={id}>
                <div
                  className={styles.icon}
                  style={{ backgroundImage: `url(${icons[img]})` }}
                ></div>
                <div className={styles.text}>{text}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default memo(UsefullBlock);
